import React, { useEffect } from 'react'
import { graphql, navigate } from 'gatsby'
import Layout from '../../shared/components/organisms/layout/layout'
import Seo from '../../shared/seo'
import SampleRequest from '../../components/organisms/sample-request/sample-request'

const IndexFreeSample = ({
  data: {
    allContentfulVConfidentMuestraGratis,
    allContentfulVConfidentTransversal,
  },
}) => {
  const haveSample = allContentfulVConfidentTransversal.nodes.filter(
    e => e.node_locale === 'es-CO' && process.env.LOCALE.includes(e.pais)
  )[0].tieneSolicitudDeMuestra

  useEffect(() => {
    if (!haveSample) navigate('/')
  }, [])

  return (
    <>
      {haveSample ? (
        <Layout title={allContentfulVConfidentMuestraGratis?.nodes[0]?.metaTitulo}>
          <Seo
            title={allContentfulVConfidentMuestraGratis?.nodes[0]?.metaTitulo}
            metaDescripcion={
              allContentfulVConfidentMuestraGratis?.nodes[0]?.metaDescripcion
                ?.metaDescripcion
            }
          />
          <SampleRequest />
        </Layout>
      ) : (
        <></>
      )}
    </>
  )
}

export const query = graphql`
  query MuestraMeta {
    allContentfulVConfidentMuestraGratis(
      #        filter: { titulo: { eq: "Muestra Gratis" } }
      filter: { slug: { eq: "muestra-gratis/" } }
    ) {
      nodes {
        metaTitulo
        metaDescripcion {
          metaDescripcion
        }
      }
    }

    allContentfulVConfidentTransversal {
      nodes {
        pais
        node_locale
        tieneSolicitudDeMuestra
      }
    }
  }
`

export default IndexFreeSample
